import React, { useEffect } from 'react';
import './App.css';
import { SidebarProvider } from 'context/SideBarContext';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from 'ProtectedRoute';
import Login from 'pages/auth/Login';
import { AuthProvider } from 'context/AuthContext';

import { Bounce, ToastContainer } from 'react-toastify';
import { useKeycloak } from '@react-keycloak/web';
import { initSentry } from 'utils/sentry';
import * as Sentry from '@sentry/react';
import '@radix-ui/themes/styles.css';

import MainRoutes from 'routes/MainRoutes';
import NotFound from 'pages/auth/NotFound';
import AddDriver from 'pages/mara/AddDriver';

function App() {
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized) {
      initSentry(keycloak);
    }
  }, [initialized]);

  useEffect(() => {
    const handleUnload = () => {
      if (keycloak.authenticated) {
        const logoutUrl = `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/logout`;
        navigator.sendBeacon(logoutUrl);
      }
    };

    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, [keycloak]);

  return (
    <AuthProvider>
      <SidebarProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <Routes>
          <Route element={<ProtectedRoute fallbackPath={'/auth/login'} />}>
            {MainRoutes()}
            <Route path="/add-driver" element={<AddDriver />} />
          </Route>

          {/* Public Routes */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </SidebarProvider>
    </AuthProvider>
  );
}

export default Sentry.withProfiler(App);
